/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery',
    'javascript-debounce'
],
    function ($,
        debounce) {

        var WRAPPER_CLASS = 'swipe__wrapper';
        var DEFAULT_BULLET_CLASS = 'swipe__bullet';
        var DEFAULT_BULLETS_CLASS = 'swipe__bullets';
        var DEFAULT_BULLET_ACTIVE_CLASS = DEFAULT_BULLET_CLASS + '--active';

        var Swiper = function Swiper(config) {
            this.init(config);
        }

        Swiper.prototype.init = function init(config) {
            this.selectors = this.getSelectors(config);
            this.initWrapper();
            this.viewModel = this.getViewModel();

            if (config.bullets) {
                this.addBullets(config);
                this.activateBullet(0);
            }

            this.initEventListeners();
        };

        Swiper.prototype.getViewModel = function getViewModel() {
            return {
                currentTile: 0,
                tilesQuantity: $(this.selectors.wrapper).children().length,
            };
        }

        Swiper.prototype.getSelectors = function getSelectors(config) {
            return {
                parent: config.swiperId,
                wrapper: '.' + WRAPPER_CLASS,
                bullets: '.' + DEFAULT_BULLETS_CLASS,
                bullet: '.' + DEFAULT_BULLET_CLASS,
                bulletActiveClass: config.bulletActiveClass ? config.bulletActiveClass : ''
            };
        }

        Swiper.prototype.initWrapper = function initWrapper() {
            var wrapper = $(this.selectors.parent).children()[0];
            $(wrapper).addClass(WRAPPER_CLASS);
        }

        Swiper.prototype.addBullets = function addBullets(config) {
            var wrapperClass = config.class || '',
                bulletClass = config.bulletClass || '',
                bullets = $('<div class=\'' + wrapperClass + ' ' + DEFAULT_BULLETS_CLASS + '\'>'),
                bullet = config.bullet || $('<div class=\'' + bulletClass + ' ' + DEFAULT_BULLET_CLASS + '\'>');

            for (var i = 0; i < this.viewModel.tilesQuantity; i++) {
                bullets.append(bullet.clone());
            }

            $(this.selectors.parent).append(bullets);
        }

        Swiper.prototype.goToNextTile = function goToNextTile(tile) {
            var nextTile = tile >= 0 && !(parseInt(tile / this.viewModel.tilesQuantity, 10))
                ? tile
                : this.viewModel.currentTile;

            if (nextTile !== this.viewModel.currentTile) {
                this.viewModel.currentTile = nextTile;
                this.activateBullet(this.viewModel.currentTile);
                this.stagePosition = -(this.viewModel.currentTile * $(this.selectors.wrapper).width() / this.viewModel.tilesQuantity) + 'px';

                $(this.selectors.wrapper).css({
                    'transform': 'translateX(' + this.stagePosition + ')',
                    '-webkit-transform': 'translateX(' + this.stagePosition + ')',
                    '-ms-transform': 'translateX(' + this.stagePosition + ')'
                });
            }
        };

        Swiper.prototype.getWrapperWidth = function getWrapperWidth() {
            return $(this.selectors.wrapper, this.selectors.parent).width();
        };

        Swiper.prototype.activateBullet = function activateBullet(bullet) {
            $(this.selectors.bullet).removeClass(DEFAULT_BULLET_ACTIVE_CLASS + ' ' + this.selectors.bulletActiveClass);
            $($(this.selectors.bullet)[bullet]).addClass(DEFAULT_BULLET_ACTIVE_CLASS + ' ' + this.selectors.bulletActiveClass);
        };

        Swiper.prototype.initEventListeners = function bindEventListeners() {
            var that = this;
            var minDistance = 50;

            $(this.selectors.parent).off('.slide').on('touchstart.slide touchend.slide touchmove.slide', this.selectors.wrapper, function (e) {
                var touches = e.originalEvent.touches;

                if (touches.length === 1) {
                    if (e.type === 'touchstart') {
                        that.startX = touches[0].clientX;
                    }

                    if (e.type === 'touchmove') {
                        that.endX = touches[0].clientX;
                    }
                }

                if (e.type === 'touchend' && Math.abs(that.endX - that.startX) > minDistance) {
                    if (that.endX > that.startX) {
                        debounce(that.goToNextTile(that.viewModel.currentTile - 1), 250);
                    } else {
                        debounce(that.goToNextTile(that.viewModel.currentTile + 1), 250);
                    }
                }
            });

            $(this.selectors.parent).off('touch').on('touch.touch click.touch', this.selectors.bullet, function () {
                debounce(
                    that.goToNextTile(
                        $(that.selectors.bullet).index(this)
                    ),
                    250
                );
            });
        }

        return {
            init: function init(config) {
                return new Swiper(config);
            },
        }

    });

}.call(window));